import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M2.993 12h18M12 20.828v-18"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export const PlusIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
